import Vue from 'vue'

// import common from './common'
const mutations = {
  SET_USER(state, payload) {
    if (process.env.NODE_ENV !== 'development') {
      if (payload) {
        Vue.prototype.$sentry.setExtra('userProp', payload)
        Vue.prototype.$sentry.setUser({
          id: payload.login,
          email: payload.email,
          username: payload.name
        })
      } else {
        Vue.prototype.$sentry.setExtra('userProp', null)
        Vue.prototype.$sentry.configureScope(scope => scope.setUser(null))
      }
    }
    state.current_user = payload
  },
  CLEAR_USER(state) {
    if (process.env.NODE_ENV !== 'development') {
      Vue.prototype.$sentry.setExtra('userProp', null)
      Vue.prototype.$sentry.configureScope(scope => scope.setUser(null))
    }
    state.current_user = null
  },
  setRouterLinks(state, payload) {
    state.routerLinks = payload
  },
  setPurchasingSettings(state, payload) {
    state.purchasingSettings = payload
  },
  setSettings(state, payload) {
    if (process.env.NODE_ENV !== 'development') {
      Vue.prototype.$sentry.setExtra('availableOrganizations', payload?.availableOrganizations)
      Vue.prototype.$sentry.setExtra('tenderSettings', payload?.tenderSettings)
      Vue.prototype.$sentry.setExtra('userAccess', payload?.userAccess)
      Vue.prototype.$sentry.setExtra('userProfile', payload?.userProfile)
    }
    state.settings = payload
  },
  setGrowthBook(state, payload) {
    const result = {}
    if (payload) {
      payload.forEach((growthbookItem) => {
        result[growthbookItem.key] = growthbookItem.value
      })
    }
    state.growthBook = result
  },
  setSurveySettings(state, payload) {
    if (payload) {

      Vue.prototype.$delete(payload, '__typename')
      if (!payload.traits) {
        return
      }
      if (process.env.NODE_ENV !== 'development') {
        Vue.prototype.$sentry.setExtra('currentOrganization', state.currentOrganization)
        Vue.prototype.$sentry.setExtra('currentUser', state.current_user)
      }
      Vue.prototype.$delete(payload.traits, '__typename')
      let data = { traits: { ...state.npsUserData?.traits, ...payload.traits } }
      if (!state.npsUserData) {
        Vue.prototype.$set(data, 'userid', state.current_user.login)
        state.npsUserData = data
      } else {
        Vue.prototype.$set(state.npsUserData, 'traits', data.traits)
      }
      /*if (process.env.NODE_ENV !== 'production') { // по факту, только для отладки
        Vue.prototype.$set(state.npsUserData, 'forceSurvey', true)
        Vue.prototype.$set(state.npsUserData.traits, 'Forced survey for TEST', '+')
      }*/
      Vue.prototype.$set(state.npsUserData, 'writeKey', payload.writeKey)
      Vue.prototype.$set(state.npsUserData, 'language', sessionStorage.getItem('language'))
      Vue.prototype.$set(state.npsUserData.traits, 'name', state.current_user.name)
      Vue.prototype.$set(state.npsUserData.traits, 'login', state.current_user.login)
      Vue.prototype.$set(state.npsUserData.traits, 'phone', state.current_user.phone)
      Vue.prototype.$set(state.npsUserData.traits, 'email', state.current_user.email)
      Vue.prototype.$set(state.npsUserData.traits, 'current_organization_OKPO',  state.currentOrganization.oKPO)
      Vue.prototype.$set(state.npsUserData.traits, 'current_organization_title', state.currentOrganization.title)
      Vue.prototype.$set(state.npsUserData.traits, 'has_errors', state.errors?.length || false)
      Vue.prototype.$set(state.npsUserData.traits, 'has_warnings', state.warns?.length || false)
      Vue.prototype.$set(state.npsUserData.traits, 'has_info', state.info?.length || false)
      Vue.prototype.$set(state.npsUserData.traits, 'new_cabinet', '+')
    }
  },
  setNpsSettings(state, payload) {
    if (payload) {
      Vue.prototype.$delete(payload, '__typename')
    }
    state.npsUserData = payload
  },
  setContractNumberAndTariff(state, payload) {
    state.contractNumberAndTariff = payload
  },
  setInstructions(state, payload) {
    state.instructions = payload
  },
  setTimezones(state, payload) {
    const lang = payload.lang || 'uk'
    const value = payload.value
    state.timezones[lang] = value
  },
}

export default mutations
